import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import {
  AlwaysOffSampler,
  AlwaysOnSampler,
  ParentBasedSampler,
  Sampler,
  SpanProcessor,
  TraceIdRatioBasedSampler,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import { resource } from './resource';

export function registerOtelTracing(
  sampling: number,
  processor?: SpanProcessor,
) {
  const provider = new WebTracerProvider({
    sampler: createSampler(sampling),
    resource,
    spanProcessors: processor ? [processor] : undefined,
  });

  provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new W3CTraceContextPropagator(),
  });

  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {},
        '@opentelemetry/instrumentation-user-interaction': {},
        '@opentelemetry/instrumentation-fetch': {},
        '@opentelemetry/instrumentation-xml-http-request': {},
      }),
    ],
  });

  return provider;
}

function createSampler(probability: number): Sampler {
  if (probability >= 1) {
    return new ParentBasedSampler({ root: new AlwaysOnSampler() });
  } else if (probability <= 0 || probability === undefined) {
    return new ParentBasedSampler({ root: new AlwaysOffSampler() });
  } else {
    return new ParentBasedSampler({
      root: new TraceIdRatioBasedSampler(probability),
    });
  }
}
